import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedCopy } from '../intl/TranslatedCopy';

const NoResults = ({ titleId, children }) => (
  <div className='text-color-secondary mt12-sm mb12-sm ta-sm-c u-full-width' data-testid='no_results'>
    <div className='headline-3 u-bold'>
      <TranslatedCopy id={titleId} />
    </div>
    {children}
  </div>
);

NoResults.defaultProps = {
  children: null
};

NoResults.propTypes = {
  titleId: PropTypes.string.isRequired,
  children: PropTypes.any
};

export default NoResults;
